import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=74fcae51&scoped=true"
import script from "./ExtendedTables.vue?vue&type=script&lang=js"
export * from "./ExtendedTables.vue?vue&type=script&lang=js"
import style0 from "./ExtendedTables.vue?vue&type=style&index=0&id=74fcae51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fcae51",
  null
  
)

export default component.exports